module.exports = __webpack_public_path__ + "assets/img/xygl__d_6.65d78e83.png";